import React, { useState } from "react";
import Countdown from "./Countdown";
import ImgTag from "../Helpers/ImgTag";

const Counter = () => {
  const [hide, setHide] = useState(false);
  return (
    <div
      className={`w-full h-screen fixed top-0 left-0 z-[9999] overflow-hidden ${
        hide ? "hidden" : "block"
      }`}
    >
      <ImgTag
        src="https://images-r2.dev-almanea.com/web-page-timer.jpg"
        className="block w-screen h-screen max-[570px]:hidden max-[991px]:object-fill"
        fill="true"
        alt="BG IMG!"
      />{" "}
      <ImgTag
        src="https://images-r2.dev-almanea.com/mega-mobile.jpg"
        className="hidden w-screen h-screen max-[570px]:block max-[991px]:object-fill"
        fill="true"
        alt="BG IMG!"
      />
      <div className="absolute max-[570px]:top-[41%] top-[47%] left-1/2 -translate-x-1/2 -translate-y-1/2  min-w-[320px] p-3 rounded-md z-20 ">
        <Countdown date="2023-10-22 09:00:00" hide={setHide} />
      </div>
    </div>
  );
};

export default Counter;
